import React, { Component } from 'react';
import Header from '../components/layout/Header2';
import PageHeader from "../components/layout/PageHeader";
import { Footer } from '../components/layout/Footer';
import axios from "axios";
import CompanyJobSeeker from '../components/layout/CompanyJobSeeker';
import CompanyWhatWeOffer from '../components/layout/CompanyWhatWeOffer';
import CompanyUserFeedback from '../components/layout/CompanyUserFeedback';
import CompanyHavingDoubt from '../components/layout/CompanyHavingDoubt';
import CompanyQueryOrIssue from '../components/layout/CompanyQueryOrIssue';
import LoadingSpinner from '../components/common/LoadingSpinner';
import ErrorMessage from '../components/common/ErrorMessage';
import EmptyState from '../components/common/EmptyState';
import { getErrorMessage } from '../utils/api';
import './../assets/css/service.css';

export class Services_details extends Component {
    state = {
        data: null,
        sub: [],
        service_id: 0,
        loading: true,
        error: null,
        notFound: false
    }

    loadData = async () => {
        const id = this.props.match?.params?.id || 0;
        this.setState({ service_id: id, loading: true, error: null, notFound: false });

        try {
            const serviceUrl = `${process.env.REACT_APP_API_URI}/services/${id}`;
            const subServiceUrl = `${process.env.REACT_APP_API_URI}/sub/services/${id}`;

            const [serviceRes, subServiceRes] = await Promise.allSettled([
                axios.get(serviceUrl),
                axios.get(subServiceUrl)
            ]);

            if (serviceRes.status === 'fulfilled') {
                const serviceData = serviceRes.value?.data?.data || serviceRes.value?.data;
                if (!serviceData || Object.keys(serviceData).length === 0) {
                    this.setState({ notFound: true, loading: false });
                    return;
                }
                this.setState({ data: serviceData });
            } else {
                if (serviceRes.reason?.response?.status === 404) {
                    this.setState({ notFound: true, loading: false });
                    return;
                }
                throw serviceRes.reason;
            }

            if (subServiceRes.status === 'fulfilled') {
                const subData = subServiceRes.value?.data?.data || subServiceRes.value?.data || [];
                this.setState({ sub: Array.isArray(subData) ? subData : [] });
            } else {
                this.setState({ sub: [] });
            }

            this.setState({ loading: false });
        } catch (err) {
            console.error('Failed to load service details:', err);
            this.setState({
                error: getErrorMessage(err),
                loading: false
            });
        }
    };

    componentDidMount() {
        this.loadData();
    }

    render() {
        const { data, sub, service_id, loading, error, notFound } = this.state;

        return (
            <div className="site-main">
                <Header />

                {/* PageHeader */}
                <PageHeader
                    title="services details"
                    breadcrumb={data?.title || 'Services'}
                />
                {/* PageHeader end */}

                {/* 1. Loading State */}
                {loading && (
                    <div className="container py-5 my-5">
                        <LoadingSpinner message="Loading service information..." />
                    </div>
                )}

                {/* 2. Error State */}
                {!loading && error && (
                    <div className="container py-5 my-5">
                        <ErrorMessage message={error} onRetry={this.loadData} />
                    </div>
                )}

                {/* 3. Not Found State */}
                {!loading && !error && (notFound || !data) && (
                    <div className="container py-5 my-5">
                        <EmptyState
                            title="Service Not Found"
                            message="The requested service could not be found or may have been removed."
                            icon="fa-search"
                            actionText="View All Services"
                            actionHref={process.env.PUBLIC_URL + '/services'}
                        />
                    </div>
                )}

                {/* 4. Found Content */}
                {!loading && !error && data && (
                    <>
                        <div className="ttm-row sidebar ttm-sidebar clearfix">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-lg-6">
                                        {data.image && (
                                            <img
                                                className="img-fluid"
                                                src={`${process.env.REACT_APP_ASSET_URL}/${data.image}`}
                                                alt={data.title || "service-img"}
                                            />
                                        )}
                                    </div>
                                    <div className="col-lg-6">
                                        <h3 className="mb-30 underline">{data.title}</h3>
                                        <p>{data.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {Array.isArray(sub) && sub.map((item, i) => {
                            if (i % 2 === 0) {
                                return (
                                    <div key={item.id || i} className="ttm-row sidebar ttm-sidebar clearfix backgroundColor">
                                        <div className="container">
                                            <div className="row align-items-center">
                                                <div className="col-lg-6">
                                                    <h3 className="mb-30 underline text-white">{item.title}</h3>
                                                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="sidebar-right">
                                                        <div className="ttm_single_image-wrapper">
                                                            <img className="img-fluid" src={`${process.env.REACT_APP_ASSET_URL}/${item.image}`} alt={item.title || "services-img"} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={item.id || i} className="ttm-row sidebar ttm-sidebar clearfix">
                                        <div className="container">
                                            <div className="row align-items-center">
                                                <div className="col-lg-6">
                                                    <div className="sidebar-right">
                                                        <div className="ttm_single_image-wrapper">
                                                            <img className="img-fluid" src={`${process.env.REACT_APP_ASSET_URL}/${item.image}`} alt={item.title || "services-img"} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <h3 className="mb-30 underline">{item.title}</h3>
                                                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        })}

                        {String(service_id) === '6' && <CompanyWhatWeOffer />}
                        {String(service_id) === '6' && <CompanyUserFeedback />}

                        <br />
                        <section className='container'>
                            <div className='row border'>
                                <div className='col-md-6 py-3 px-2'>
                                    {String(service_id) === '6' ? <CompanyHavingDoubt status="2" /> : (String(service_id) === '1' ? <CompanyHavingDoubt status="1" /> : null)}
                                </div>
                                <div className='col-md-6 pr-0 '>
                                    {String(service_id) === '6' ? <CompanyQueryOrIssue id="0" /> : (String(service_id) === '1' ? <CompanyQueryOrIssue id="6" /> : null)}
                                </div>
                            </div>
                        </section>
                    </>
                )}

                <CompanyJobSeeker />
                <Footer />
            </div>
        );
    }
}

export default Services_details;